export { default as default } from './modules/readXlsxFileBrowser'
export { default as convertToJson } from './modules/convertToJson'
export { default as Integer } from './modules/types/Integer'
export { default as Email } from './modules/types/Email'
export { default as URL } from './modules/types/URL'
export { default as parseExcelDate } from './modules/parseDate'


//////////////////
// WEBPACK FOOTER
// ./~/read-excel-file/index.js
// module id = 2506
// module chunks = 1